module.exports = __webpack_public_path__ + "static/media/logo-nave-icon.217bd39b.svg";